// extracted by mini-css-extract-plugin
export default {"container":"processing-claims_container__xqOXq"};